// extracted by mini-css-extract-plugin
export default {"Notifications":"styles_Notifications__HulPL","notificationsList":"styles_notificationsList__+PyXc","overlay":"styles_overlay__jAD21"};